import React from 'react';
import { PriceRoundingContainer } from './PriceRoundingContainer';
import { Typography } from '@mui/material';

export const PriceRoundingBrandContainer: React.FC = () => {
  return (
    <PriceRoundingContainer
      renderConfigEntryHeading={(ruleSetConfig) => (
        <Typography variant="h5" component="h2">
          {ruleSetConfig.name}
        </Typography>
      )}
    />
  );
};
